import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A1329] text-white flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full rounded-2xl border border-white/10 bg-[#0F1A38] p-10 text-center">
        <div className="h-14 w-14 rounded-full bg-slate-500/20 border border-slate-400/30 flex items-center justify-center mx-auto mb-4">
          <XCircle className="h-8 w-8 text-slate-300" />
        </div>
        <h1 className="font-display font-bold text-3xl">Checkout cancelled</h1>
        <p className="text-slate-300 mt-3">No charge was made. Have questions? We're happy to help.</p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to="/pricing"><Button className="bg-riskeye-cyan text-[#0A1329] hover:bg-cyan-300 font-semibold">Back to pricing</Button></Link>
          <a href="mailto:sales@riskeye.io"><Button variant="outline" className="bg-white/5 border-white/20 text-white hover:bg-white/10 hover:text-white">Email sales</Button></a>
        </div>
      </div>
    </div>
  );
}
